import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";

import { Influencer, InfluencerContact } from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import { Review } from "@shared/lib/types/agency";

export function useAddReview() {
  const {
    mutate: addReview,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation<
    { influencerId: string; review: Pick<Review, "comment" | "review"> },
    BackednResponse<Influencer> | void
  >({
    mutationFn: async ({ influencerId, review }) => {
      return await InfluencerService.addReview(influencerId, review).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { influencerId }) => {
      c.invalidateQueries({ queryKey: INFLUENCER_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, influencerId],
      });
    },
  });

  return {
    addReview,
    isAdding,
    isAdded,
  };
}
